import XEUtils from 'xe-utils'

import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import {mapGetters} from "vuex";
import {reportYear} from "../../util/util";
Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {
    getLatest:Boolean,
  },
  data: () => {

    return {
      order: {
        'AAA': 0,
        'AA': 1,
        'A': 2,
        'BBB': 3,
        'BB': 4,
        'B': 5,
        'CCC': 6,
        'CC': 7,
        'C': 8
      },
      data: [],
      dataRaw: [
        {'rating': 'AAA'},
        {'rating': 'AA'},
        {'rating': 'A'},
        {'rating': 'BBB'},
        {'rating': 'BB'},
        {'rating': 'B'},
        {'rating': 'CCC'},
        {'rating': 'CC'},
        {'rating': 'C'}
      ],
      tableColumn: [],
      tableColumnRaw: [
        {title: "ESG评级", field: "rating", fixed: "left"},
      ],
      entityCount:0,
      gicsMap:new Map(),
      loading: false,
      report_date: null,
      rawColumns: null,
    }
  },
  methods: {
    getESGData() {
      let self = this
      let year = self.year
      self.loading = true
      let params = new Map()
      if (year && !self.getLatest) {
        params.set("year", year)
      }
      httpManager("esg_entity_statistics", params)
        .then(response => {
          self.entityCount = 0
          self.gicsMap = new Map(),
          self.data = []
          self.data.push.apply(self.data, self.dataRaw)
          self.tableColumn = []
          self.tableColumn.push.apply(self.tableColumn, self.tableColumnRaw)
          self.report_date = response.data.data.reportDate
          let midData = {}
          self.rawColumns.forEach(function (d) {
            if(d['major_industry_valid'] === '已终止' || d['sub_industry_valid'] === '已终止') {
              return
            }
            let dat = {
              parentId: d['major_industry_code'] + "",
              field: d['sub_industry_code'],
              id: d['sub_industry_code'] + "",
              title: d['sub_industry'],
              visible: false
            }
            for (let i = 0; i < 9; i++) {
              self.data[i][d['sub_industry_code'] + ""] = 0
              self.data[i][d['major_industry_code'] + ""] = 0
            }

            if (!(dat["parentId"] in midData)) {
              midData[dat["parentId"]] = {
                id: d['major_industry_code'] + "",
                title: d['major_industry'],
                field: "",
                slots: {
                  header: "num1_height"
                },
              }
            }
            if (!(dat["parentId"] + "_sub" in midData)) {
              midData[dat["parentId"] + "_sub"] = {
                id: d['major_industry_code'] + "_sub",
                title: "",
                field: d['major_industry_code'] + "",
                parentId: d['major_industry_code'] + "",
              }
            }
            midData[dat["id"]] = dat
          })
          let midList = [];

          for (let k in midData) {
            midList.push(midData[k]);
          }

          let columns = XEUtils.toArrayTree(midList)
          self.tableColumn.push.apply(self.tableColumn, columns)
          let rawData = response.data.data.data
          rawData.forEach(function (a) {
            self.entityCount += a['count']
            if(!self.gicsMap.has(a['gics'].toString())){
              self.gicsMap.set(a['gics'].toString(),0)
            }
            self.gicsMap.set(a['gics'].toString(),self.gicsMap.get(a['gics'].toString())+a['count'])
            self.data[self.order[a['name']]][a['gics'].toString()] = a['count']
          });
          self.entityCount = self.entityCount/2
          self.loading = false
          self.collapsableCloumns()
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    collapsableEvent(selectCol) {
      let self = this
      const xTable = self.$refs.xTable
      selectCol.column.children.forEach(col => {
        for(let i = 0; i < self.data.length; i++) {
          col.visible = !col.visible
        }
      })
      xTable.refreshColumn()
    },
    collapsableCloumns() {
      let self = this
      const xTable = self.$refs.xTable
      xTable.columns.forEach(col => {
        if (col.children) {
          col.children.forEach(col => {
            if (col.title == '' || col.title == undefined) {
              col.visible = true
            } else {
              col.visible = false
            }
          })
        }
      })
      xTable.refreshColumn()
    },
    cellStyle({row, rowIndex, column, columnIndex}) {
      let opacity=row[column.property]/this.gicsMap.get(column.property)
      return {
        backgroundColor: 'rgba(201,37,37,'+opacity+')',
        color: 'black',
        cursor: 'pointer',
        'font-size': '14px'
      }
    },
    cellClickEvent({row, column}) {
      if(column.property.length<=2){
        let parentColumn = this.$refs.xTable.getColumnById(column.parentId)
        parentColumn.children.forEach(col => {
        col.visible = !col.visible
        })
        this.$refs.xTable.refreshColumn()
        return
      }
      this.$emit("zifu", column.property, row.rating);
    },
    getGics(){
      let self = this
      reportYear.gics("gics_columns_"+this.$i18n.locale).then(result => {
            self.rawColumns = result
      })
    },
  },
  mounted() {
    this.getGics()
    this.getESGData()
  },
  computed: mapGetters('esg', {
    year: 'report'
  }),
  watch: {
    year: function () {
      this.getESGData()
    },
    // report_date: function () {
    //   this.$store.commit('esg/esgReport', {year: this.report_date})
    // }
  }
}
Vue.component("esg-industry-rating-table", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_industry_rating_table.js